import React from "react"

export const PayerStatusLoadingComponent: React.FunctionComponent = () => {
    return (
        <div
            role="status"
            aria-busy="true"
            aria-label="Loading payer status"
            className="flex flex-col gap-[32px]"
        >
            <div className="flex flex-col gap-[12px]">
                <div className="h-[24px] w-[160px] motion-safe:animate-pulse rounded-[6px] bg-brand-warmLight2" />

                <div className="grid grid-cols-[repeat(auto-fit,minmax(260px,1fr))] gap-[16px]">
                    {[0, 1].map(index => (
                        <div
                            key={index}
                            className="h-[200px] motion-safe:animate-pulse rounded-[16px] bg-brand-warmLight2"
                        />
                    ))}
                </div>
            </div>

            <div className="h-[240px] motion-safe:animate-pulse rounded-[16px] bg-brand-warmLight2" />

            <div className="overflow-hidden rounded-[16px] bg-brand-white shadow-sm">
                {/*Different name widths, so rows look like a list*/}
                {[186, 132, 210, 156, 114, 198, 144, 174].map(
                    (width, index) => (
                        <div
                            key={index}
                            className="flex items-center justify-between gap-[16px] border-0 border-b border-solid border-brand-warmLight2 px-[20px] py-[18px]"
                        >
                            <div className="flex flex-col gap-[8px]">
                                <div
                                    className="h-[14px] max-w-[50vw] motion-safe:animate-pulse rounded-[6px] bg-brand-warmLight2"
                                    style={{ width }}
                                />

                                <div className="h-[10px] w-[56px] motion-safe:animate-pulse rounded-[6px] bg-brand-warmLight2" />
                            </div>

                            <div className="h-[26px] w-[112px] motion-safe:animate-pulse rounded-full bg-brand-warmLight2" />
                        </div>
                    ),
                )}
            </div>
        </div>
    )
}
